import { render, staticRenderFns } from "./EduClassOrder.vue?vue&type=template&id=cf67f22e&scoped=true"
import script from "./EduClassOrder.vue?vue&type=script&lang=js"
export * from "./EduClassOrder.vue?vue&type=script&lang=js"
import style0 from "./EduClassOrder.vue?vue&type=style&index=0&id=cf67f22e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cf67f22e",
  null
  
)

export default component.exports